// extracted by mini-css-extract-plugin
export default {"grid_container":"section_grid_container__kJ1e0","box":"section_box__hxlPZ"};